import { Base2Presenter } from "core/presenter";
import { CompanyRepository } from "core/repository";

export default class UserPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: false,
      filter: {},
      companySearchOptions: {
        online: true,
        repository: CompanyRepository,
        order: [{ field: "slug", direction: "ASC" }],
        pagination: { page: 1, perPage: 25 },
        filter: filter => this.getFilter(filter)
      }
    };
  }

  getFilter(filter) {
    return [
      { connector: "AND", field: "slug", operation: "LIKE", value: filter },
      {
        connector: "OR",
        field: "fiscal_informations.cnpj",
        operation: "LIKE",
        value: filter
      },
      {
        connector: "OR",
        field: "fiscal_informations.legal_name",
        operation: "LIKE",
        value: filter
      }
    ];
  }

  setLoading = async value => {
    this.enqueue({ loading: value });
  };

  handleFilterChange = filter => {
    this.enqueue({ filter });
  };
}



// WEBPACK FOOTER //
// ./src/components/app/registration/user/user.presenter.js